type MinicartIconContainerProps = { children: React.ReactNode };

const MinicartIconContainer = ({ children }: MinicartIconContainerProps) => {
	return (
		<span className={`minicartIconContainer vtex-minicart-2-x-minicartIconContainer gray relative`}>{children}</span>
	);
};

export default MinicartIconContainer;
